import HomePageContent from './Resources/homePageContent';
import SupportedSymbols from './Resources/DisplaySymbol';

export default function Home() {
  return (
    <>
      <HomePageContent />
      <SupportedSymbols />
    </>
  );
}
